// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3TjOM","footer":"ModalFilter_footer__31oE9"};